import { Grid, Stack } from "@mui/material";
import TopSection from "../../../Components/Common/Top/TopSection";
import RealignmentList from "./RealignmentList";
import { ToastContainer } from "react-toastify";


const ActionDashboard = () => {
  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection
              title="Master Data/Realignment Actions"
            />
            <div class="container">
              {/* top table */}
              <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />
              <RealignmentList/>
             
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default ActionDashboard;

